import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { INVOICE_CODE } from "../apiRoutes";

const mutateAddInvoiceCode = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(INVOICE_CODE, data);
};

const useAddInvoiceCodesMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: mutateAddInvoiceCode,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch geo regions queries
      queryClient.invalidateQueries({
        queryKey: ["invoiceCodes"],
        exact: false,
      });
      queryParams?.onSuccess?.(data, variables, context);
    },
    ...queryParams,
  });
};

export default useAddInvoiceCodesMutation;
